var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ff8c08",
    stroke: "#ff8c08",
    strokeWidth: 3.072,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ff8c08;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 284.7,
    cy: 66.7,
    r: 44.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "327.9,222 388.4,249.7 459.3,202.4 445.9,174.5 395.3,203.2 301.9,140.8 249.6,140.8 244.8,220.7 240.3,295 299.1,341.4 346.3,378.7 342.3,477.8 382.4,477.8 403.5,344.8 326.3,272.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "240.3,372.1 218.6,477.8 254.5,477.8 294.9,387.6 297.6,358.1 240.3,312.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.6,223.4l4.3-70.3l-63.2,52.6l-19.9,65.9h-11.4c-3.5,0-6.5,2.6-6.9,6.1l-7.2,57.7c0,0,0,0.1,0,0.1 l-0.1,0.7H79.8c-8.8,0-16.2,6.7-17.1,15.4l-9.9,95.1c-1.1,10.2,6.9,19,17.1,19H82C82,445,99,428,119.8,428c1.3,0,2.7,0.1,3.9,0.2 c2.4,0.2,4.7,0.7,6.9,1.4l9.6-92.5l6.4-51.5h39.5c3.9,0,7-3.1,7-7c0-3-1.8-5.5-4.4-6.5L206,228L230.6,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.3,442.1c-0.8-0.1-1.6-0.1-2.5-0.1c-13.2,0-23.9,10.7-23.9,23.9s10.7,23.9,23.9,23.9s23.9-10.7,23.9-23.9 C143.7,453.5,134.3,443.4,122.3,442.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourism);
export default __webpack_public_path__ + "static/media/tourism.37230c9262a193016d2b10b1977e7999.svg";
export { ForwardRef as ReactComponent };